import i18next from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import styles from './Footer.module.scss';
import de from './i18n/de.json';
import nutzungsbedingungen from '../../assets/resources/IHP-COP-060_Nutzungsbedingungen_Kundenportal.pdf';
import { getCompanyConfig } from '../../redux/Company/selectors';

i18next.addResourceBundle('de', 'app/Footer', de);

function Footer(props) {
  const { t } = useTranslation('app/Footer');
  const companyConfiguration = useSelector(getCompanyConfig);
  const currentDate = new Date(Date.now());

  return (
    <footer className={styles.outer}>
      <div className={styles.inner}>
        {companyConfiguration?.style?.copyright || `© ${currentDate.getFullYear()} Interhyp AG`}
        {/* The following can only be seen by employees of the Interhyp having companyId 3*/}
        {companyConfiguration?.companyId === 3 && (
          <>
            <p className={styles.awardDescription}>{t('awardDesc')}</p>
            <p className={styles.linkLine}>
              <a
                className={styles.legalLink}
                href="https://www.interhyp.de/ueber-interhyp/datenschutz/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('dataProtection')}
              </a>
              <a
                className={styles.legalLink}
                href="https://www.interhyp.de/impressum/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('imprint')}
              </a>
              <a
                className={styles.legalLink}
                href={nutzungsbedingungen}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('toc')}
              </a>
            </p>
          </>
        )}
      </div>
    </footer>
  );
}
export { Footer };
